module.exports = __webpack_public_path__ + "img/yz.c9f39e13.png";